<template>
  <transition name="fade" mode="out-in" appear>
    <section class="ls-login-parent">
      <div class="ls-login-inner">
        <div class="ls-login-container">
          <div class="ls-login-box">
            <h1 class="ls-login-logo">
              <img src="../../../assets/img/logo.svg">
            </h1>
            <flash-message></flash-message>
            <div v-if="!havePassword">
              <form class="ls-form ls-login-form" role="form" @submit.prevent="validateBeforeSubmit">
                <fieldset>
                  <label class="ls-label" :class="{'ls-error': errors.has($t('login.mail')) }">
                    <b class="ls-label-text ls-hidden-accessible">{{ $t('login.user') }}</b>
                    <div class="ls-prefix-group">
                      <span class="ls-label-text-prefix"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                      <input
                        id="email"
                        class="form-control"
                        type="email"
                        v-model="email"
                        v-validate="'required|email'"
                        disabled
                        :placeholder="$t('login.mail')"
                        :name="$t('login.mail')" />
                    </div>
                    <small v-show="errors.has($t('login.mail'))" class="ls-help-message">{{ errors.first($t('login.mail')) }}</small>
                  </label>
                    <label class="ls-label" :class="{'ls-error': errors.has($t('login.password')) }">
                      <b class="ls-label-text ls-hidden-accessible">{{ $t('login.password') }}</b>
                      <div class="ls-prefix-group">
                        <span class="ls-label-text-prefix"><i class="fa fa-lock" aria-hidden="true"></i></span>
                        <input
                          id="password"
                          class="form-control"
                          v-model="password"
                          name="user.password"
                          type="password"
                          v-validate="'required|min:6'"
                          :placeholder="$t('login.password')"
                          :name="$t('login.password')" />
                      </div>
                      <small v-show="errors.has($t('login.password'))" class="ls-help-message">{{ errors.first($t('login.password')) }}</small>
                    </label>
                    <button :disabled="!enableButton" class="ls-btn-primary ls-btn-block ls-btn-lg" type="submit">{{ $t('application.button.save') }}</button>
                </fieldset>
              </form>
            </div>
            <div v-else>
              <h3 class="ls-txt-center">{{ $t('application.reset_password.already_registered')}}</h3>
              <button @click="redirectToSubscribe" class="ls-btn-primary ls-btn-block ls-btn-lg" type="submit">{{ $t('application.button.contract') }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import MaterialInput from '../../components/shareds/MaterialInput.vue'
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'NewPassword',
    components: { Breadcrumb, MaterialInput },
    data () {
      return {
        password: '',
        enableButton: true,
        havePassword: false,
        email: '',
        parsedCust: {}
      }
    },
    mounted () {
      this.$loader.show()
      this.getCustomer()
    },
    computed: {
      disableButton () {
        this.enableButton = false
      }
    },
    methods: {
      ...mapActions(['loadCustomer', 'definePassword']),
      ...mapMutations(['clearFlash']),
      ...mapGetters(['customer']),
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validate().then(this.afterValidate)
      },
      afterValidate (response) {
        if (response === false) {
          this.$loader.hide()
          return
        }
        this.parseCustomerAttributes()
        this.setPassword().then(this.afterSave)
      },
      afterSave (response) {
        if (response && response.status === 200) {
          this.$loader.hide()
          setTimeout(this.redirectToSubscribe, 4000)
          this.disableButton()
        } else {
          setTimeout(this.clearFlash, 3000)
          this.$loader.hide()
        }
      },
      redirectToSubscribe () {
        this.$router.push('/subscribe')
      },
      getCustomer () {
        this.loadCustomer(this.$route.params.token).then(this.setCustomer)
      },
      setCustomer (response) {
        if (response && response.status === 200) {
          this.email = response.data.customer.email
          this.havePassword = response.data.customer.have_password
        }
        this.$loader.hide()
      },
      setPassword () {
        return Promise.resolve(this.definePassword(this.parsedCust))
      },
      parseCustomerAttributes () {
        this.initializeParsedCust()
        this.parseCustAttributes()
      },
      initializeParsedCust () {
        this.parsedCust = {}
      },
      parseCustAttributes () {
        this.parsedCust.email = this.email
        this.parsedCust.password = this.password
        this.parsedCust.id = this.$route.params.token
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Password.vue?fe3978c6